import { Component, OnInit } from '@angular/core';
import { CampusUnitsMessageService } from '../../services/data/campus-units-message.service';
import { CampusUnitMessage } from '../../models/notifications/campus-unit-message.model';
import { CampusUnitMessageEditDialogComponent } from './campus-unit-message-edit-dialog/campus-unit-message-edit-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-campus-unit-message',
  templateUrl: './campus-unit-message.component.html',
  styleUrls: ['./campus-unit-message.component.scss']
})
export class CampusUnitMessageComponent implements OnInit {

  messages: CampusUnitMessage[] = [];
  canShowMessages = false;
  loading = true;

  constructor(private messageService: CampusUnitsMessageService, private matDialog: MatDialog) { }

  ngOnInit() {
    this.loadMessages();
  }

  loadMessages() {
    this.loading = true;
    this.canShowMessages = false;

    this.messageService.getAllMessages().subscribe(result => {
      this.messages = result;
      this.sortMessages();
      this.loading = false;

      if (this.messages && this.messages.length > 0) {
        this.canShowMessages = true;
      }

    }, error => {
      this.canShowMessages = false;
      this.loading = false;
    })
  }


  /**
   * Create a new message
   */
  onCreateNewMessage() {
    const isEdit = false;
    const dialogRef = this.openEditDialog(isEdit);

    const onfinishEvent = dialogRef.componentInstance.onFinishedCreate.subscribe(result => {
      this.onCreateMessageFinished(result);
    })

    dialogRef.afterClosed().subscribe(data => {
      onfinishEvent.unsubscribe();
    })
  }

  /**
   * This function is called after the user finish editing a new message
   * @param newMessage the new message
   */
  onCreateMessageFinished(newMessage: CampusUnitMessage) {
    if (!newMessage) {
      return; // TODO: show error message
    }

    this.messageService.createMessage(newMessage).subscribe(result => {
      if (result) {
        this.messages.push(result);
        this.sortMessages();
      }
    });
  }


  /**
   * Edit an existing message
   * @param currentMessage the message to be edited
   */
  editMessage(currentMessage: CampusUnitMessage) {

    if (!currentMessage) {
      return;
    }

    const isEdit = true;
    const dialogRef = this.openEditDialog(isEdit, currentMessage);

    const editEvent = dialogRef.componentInstance.onFinishedEdit.subscribe(result => {
      this.onEditMessageFinished(result);
    })

    dialogRef.afterClosed().subscribe(data => {
      editEvent.unsubscribe();
    })
  }

  onEditMessageFinished(editRequest: any) {
    if (!editRequest || !editRequest.currentMessage || !editRequest.newMessage) {
      return; // TODO: show error message
    }

    const currentMessage: CampusUnitMessage = editRequest.currentMessage;
    const newMessage: CampusUnitMessage = editRequest.newMessage;

    const index = this.messages.indexOf(currentMessage);
    if (index < 0) {
      return;
    }

    this.messageService.updateMessage(currentMessage.campusUnitsMessageId, newMessage).subscribe(result => {
      if (result) {
        this.messages[index] = result;
        this.sortMessages();
      }
    })

  }

  /**
   * Disable or activate a message
   * @param message the message to be edited
   */
  toggleMessageActiveState(message: CampusUnitMessage) {
    if (!message) {
      return;
    }

    const index = this.messages.indexOf(message);
    if (index < 0) {
      return;
    }

    const today = new Date();

    let newMessage = new CampusUnitMessage();
    newMessage = Object.assign(message);

    if (message.active) {
      newMessage.active = false;
    } else {
      newMessage.active = true;
    }

    this.messageService.updateMessage(message.campusUnitsMessageId, newMessage).subscribe(result => {
      if (result) {
        this.messages[index] = result;
        this.sortMessages();
      }
    });
  }

  /**
   * Opens a dialog box to create/edit a message
   * @param edit sinifies if this is an edit or not
   * @param currentMessage optional. Required if it's an edit request
   */
  private openEditDialog(edit: boolean, currentMessage: CampusUnitMessage = null) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;

    if (currentMessage) {
      dialogConfig.data = {
        currentMessage: currentMessage
      };
    }


    dialogConfig.height = 'auto';
    dialogConfig.width = '70%';

    return this.matDialog.open(CampusUnitMessageEditDialogComponent, dialogConfig);
  }

  sortMessages() {
    this.messages.sort((a, b) => {
      if (a.active && !b.active) {
        return 1;
      }
      if ((a.active && b.active) && (a.endDate > b.endDate)) {
        return 1;
      }
      if ((a.active && b.active) && (a.endDate < b.endDate)) {
        return -1;
      }


      if (!a.active && b.active) {
        return -1;
      }
      if ((!a.active && !b.active) && (a.endDate > b.endDate)) {
        return 1;
      }
      if ((!a.active && !b.active) && (a.endDate < b.endDate)) {
        return -1;
      }

      return 0;
    });
    this.messages.reverse();
  }

}
